import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_ENABLE_LISP_NEXT_PAGE_PREFETCH_BUG_FIX_250527 } from "@faire/retailer-settings/FE_ENABLE_LISP_NEXT_PAGE_PREFETCH_BUG_FIX_250527";

export const useSettingFEEnableLISPNextPagePrefetchingBugFix = (): boolean => {
  return useSetting(FE_ENABLE_LISP_NEXT_PAGE_PREFETCH_BUG_FIX_250527);
};
export const useAssignSettingFEEnableLISPNextPagePrefetchingBugFix = () =>
  useAssignSetting(FE_ENABLE_LISP_NEXT_PAGE_PREFETCH_BUG_FIX_250527);
